import { useSelector } from "react-redux";
import underConstructionVector from "../../image/under-construction.svg";

const UnderConstruction2 = () => {

    const Dictionary = useSelector(state => state.VisualData.Dictionary);
    const LAN = useSelector(state => state.VisualData.LAN);

    return (
        <div className="bg-white">
            <div className="section-vertical-padding underconstruction-wrapper page-container text-center">
                <img src={underConstructionVector} alt={Dictionary.underConstruction} className="image" />

                {LAN === "IR" ? (
                    <div dir="ltr" className="en-font">
                        <h2 className="large-title"> 
                            {/* ما در حال ارتقاء سرورها هستیم.  */}
                            Scheduled Maintenance in Progress
                        </h2>
                        <p>
                            We’re currently migrating our servers to improve performance and reliability. During this time, our website will be temporarily unavailable.
                            <br/>
                            Thank you for your patience. we’ll be back online shortly!
                            {/* به‌زودی برمی‌گردیم. از شکیبایی شما سپاسگزاریم. */}
                        </p>
                    </div>
                ) : (
                    <>
                        <h2 className="large-title"> {Dictionary.underConstruction} </h2>
                        <p>{Dictionary.weAreMakingLotsOfImprovementsAndWillBeBackSoon}</p>
                    </>
                )}
            </div>
        </div>
    )
}

export default UnderConstruction2;